import PageContainer from 'components/PageContainer';
import PageHeading from 'components/PageHeading';
import useAuthStore from 'store/authStore';

function HomePage() {
  const { token, tokenAccessRoles } = useAuthStore();
  return (
    <PageContainer>
      <PageHeading>Home</PageHeading>
      <h2>Welcome {token?.account.name}!</h2>
      <div className="pt-4">
        Roles:
        <ul className="pl-8">
          {tokenAccessRoles.map((role) => (
            <li key={role} className="list-disc">
              {role}
            </li>
          ))}
        </ul>
      </div>
    </PageContainer>
  );
}

export default HomePage;
